import { render, staticRenderFns } from "./RcvRL_Action.vue?vue&type=template&id=b5b7d742"
import script from "./RcvRL_Action.vue?vue&type=script&lang=js"
export * from "./RcvRL_Action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports